import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import useHelpers from "@hooks/useHelpers";
var CarRejectedScreen = function CarRejectedScreen() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var handleNewOrder = function handleNewOrder() {
    navigateToHard("/site/sell-my-car");
  };
  var handleGoHome = function handleGoHome() {
    navigateTo("/");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hasMobFooter: false,
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:bg-blue-alice md:min-h-[285px]"
  }), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-rejected-screen",
    className: "px-4 mt-[100px]  md:max-w-[600px] md:mx-auto md:mt-[-200px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-4 pb-8 flex flex-col gap-8 md:border md:border-solid md:border-gray-echo md:rounded-2xl md:pt-[60px] md:pb-[70px] md:bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-rejected-icon",
    src: CDN_LINK + "/assets/images/location-rejected-icon.svg",
    alt: "",
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 items-center"
  }, /*#__PURE__*/React.createElement("h3", {
    id: "sell-car-rejected-title",
    className: "text-base text-primary-new font-bold text-center leading-10"
  }, tShort("sell_trade_v2/car_rejected_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-rejected-description",
    className: "text-black-primary text-base text-center leading-7 max-w-[310px]"
  }, tShort("sell_trade_v2/car_rejected_description", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    id: "sell-car-rejected-apply-again-btn",
    className: "w-full cursor-pointer border-none bg-primary-new text-white p-3 rounded-lg outline-none text-base font-semibold md:max-w-[330px] md:mx-auto",
    onClick: handleNewOrder
  }, tShort("sell_trade_v2/apply_again", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("button", {
    id: "sell-car-rejected-home-btn",
    className: "w-full border border-solid border-primary-new rounded text-center text-primary-new text-base px-4 py-3 font-semibold cursor-pointer md:max-w-[330px] md:mx-auto bg-white",
    onClick: handleGoHome
  }, tShort("sell_trade_v2/go_home", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-[95px] md:mt-6"
  }, /*#__PURE__*/React.createElement(AnyQuestion, {
    containerClassName: "!w-full"
  }))))));
};
export default CarRejectedScreen;